import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Globe, Lock, Sparkles, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-surface relative" data-id="element-175" data-mp="1j9756u290rzz">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-176" data-mp="1nakbf5996x7f">
        <div className="text-center mb-10" data-id="element-177" data-mp="1na0t3nfoy6sv">
          <h2 className="text-3xl md:text-5xl font-display font-bold uppercase mb-3 text-primary" data-id="element-178" data-mp="1s9n9g5qtg35w">
            Your Complete{' '}
            <span className="text-secondary" data-id="element-179" data-mp="1x9rpjuntavvl">Automotive Technology Instructor Ready</span> Package
          </h2>
          <p className="text-primary/75 text-sm md:text-base" data-id="element-180" data-mp="226i5mhzm9rh0">
            The Complete Teaching System — Ready for Your Next Class
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-primary border-2 border-accent rounded-2xl p-1 relative shadow-xl shadow-primary/15" data-id="element-181" data-mp="7tih1zd9dmxl">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-primary font-bold px-5 py-1.5 rounded-md shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-182" data-mp="1crwqjdvtv9ep">
            <Sparkles size={14} data-id="element-183" data-mp="25e7n8dgbcq68" /> Complete Package
          </div>
          <div className="bg-white rounded-[0.85rem] p-6 md:p-10 text-center" data-id="element-184" data-mp="20fxwcf1mgbqf">
            <h3 className="text-2xl md:text-3xl font-display font-bold text-primary mb-1 tracking-wide" data-id="element-185" data-mp="1vhcs84j917wp">
              AUTOMOTIVE TECHNOLOGY INSTRUCTOR READY
            </h3>
            <p className="text-lg md:text-xl font-display font-bold text-secondary mb-3" data-id="element-186" data-mp="1rhu99eazn6wi">
              Complete 6-in-1 Visual Teaching System
            </p>
            <p className="text-base text-body mb-6" data-id="element-187" data-mp="fzjdkjz3xmbw">You receive:</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-surface border border-primary/15 rounded-lg p-4" data-id="element-188" data-mp="hi19vvl55ugp">
              {packageIncludes.map(item => <li key={item.label} className="flex items-start gap-2 text-sm text-body" data-id="element-189" data-mp="meryj7b0hydq">
                  {item.kind === 'bonus' ? <Gift size={16} className="text-accent-strong shrink-0 mt-0.5" data-id="element-190" data-mp="ci5euluf9dda" /> : <Check size={16} className="text-secondary shrink-0 mt-0.5" data-id="element-191" data-mp="3uwebk8m8sdp2" />}
                  <span data-id="element-192" data-mp="3i8kc3lcpkab">{item.label}</span>
                </li>)}
            </ul>

            <div className="mb-6 bg-primary rounded-lg py-4 px-4" data-id="element-193" data-mp="3kz9q6b080m9b">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-194" data-mp="3pxkyuies4qpy">
                <span className="text-2xl md:text-3xl font-display font-bold text-white/80" data-id="element-195" data-mp="3pvgtrx559lo3">
                  TODAY:
                </span>
                <span className="text-4xl md:text-5xl font-display font-bold text-accent" data-id="element-196" data-mp="3fznbdx4quxye">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-197" data-mp="2sc0alkrfurd4">
              GET AUTOMOTIVE TECHNOLOGY INSTRUCTOR READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-muted mb-4" data-id="element-198" data-mp="31et0pkovwx1d">
              <span className="flex items-center gap-1.5" data-id="element-199" data-mp="3g7utv083smia">
                <Lock size={12} className="text-secondary" data-id="element-200" data-mp="3b9tcqku8mx9g" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-201" data-mp="3p17u6n8hyqee">
                <Zap size={12} className="text-secondary" data-id="element-202" data-mp="3l0nxfkru5oss" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-203" data-mp="2v2k051xn843">
                <Check size={12} className="text-secondary" data-id="element-204" data-mp="2vkotq2nuunm" /> Complete Digital PDF Bundle
              </span>
            </div>

            <div className="bg-surface border border-primary/15 rounded-lg p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-205" data-mp="3tzj4ez2pf2x5">
              <Globe className="text-primary shrink-0 mt-0.5" size={14} data-id="element-206" data-mp="lz5zpfshtmyu" />
              <p className="text-[11px] text-muted leading-snug" data-id="element-207" data-mp="qqebgihapkf6">
                🌍 Payment availability and currency conversion may vary according to your checkout
                provider and country.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}